
<div class="container-fluid my-5">
    <div class="row">
        <div class="col">
            <div class="card shadow">
                <div class="row">
                    <div class="col-md-12 text-right">
                        <h3 class="badge badge-info">La synchronisation des données peut prendre quelques minutes</h3>
                    </div>
                </div>
                <app-custom-table [index]="index" [custom_page]="custom_page" [columns]="columns" [show_add_button]="show_add_button"
                    [show_delete_button]="show_delete_button" [multi_actions]="multi_actions"
                    [visible_actions]="visible_actions" [invisible_actions]="invisible_actions"
                    [custom_buttons]="custom_buttons"></app-custom-table>
            </div>
        </div>
    </div>
</div>